module.exports = __webpack_public_path__ + "img/business.21ff3055.jpg";